module.exports = __webpack_public_path__ + "img/logo-hdemia.2f5075d0.jpg";